import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../../../../../../../components";
import { deleteProduct } from "../../../../../../../../../../../../store/conventionsSlice";
import { getSelfServiceCnameSelector } from "../../../../../../../../../../../../store/selfServiceSlice";
import {
  IMAGES,
  MODAL_ID,
} from "../../../../../../../../../../../../utils/constants";

/**
 * @desc Product delete modal.
 */
export const ProductDeleteModal = ({ product }) => {
  const dispatch = useDispatch();
  const cname = useSelector(getSelfServiceCnameSelector);

  // HANDLERS -----------------------------------------------------------------

  /**
   * @desc Handle product deletion.
   */
  const handleDeleteProduct = async () => {
    try {
      await dispatch(deleteProduct({ sku: product.sku, cname }));
      toast.success("Success");
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    }
  };

  // COMPONENT ----------------------------------------------------------------

  const modalProps = {
    id: `${MODAL_ID.DELETE_PRODUCT}-${product.sku}`,
    header: "Delete a Product",
    children: (
      <div className="delete-product-modal">
        <img
          className={"product-image"}
          src={product.image || IMAGES.PRODUCT.DEFAULT}
          alt={product.name}
        />
        <div className="column">
          <div>Are you sure you want to delete product:</div>
          <p className="sku">{product.sku}</p>
        </div>
      </div>
    ),
    ctaText: "YES, DELETE",
    showCancelButton: true,
    onClick: handleDeleteProduct,
  };

  return <Modal {...modalProps} />;
};

export default ProductDeleteModal;
